// slide02
var paginationText = $(".slide02 .pagination_text li");
var slide02 = new Swiper(".slide02", {
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.slide02 .swiper-button-next',
        prevEl: '.slide02 .swiper-button-prev',
    },
    pagination: {
        el: ".slide02 .swiper-pagination",
        clickable: true,
        bulletActiveClass : 'on',
        renderBullet: function (index, className) {
            return '<p class="' + className + '"><span>' + (paginationText.eq(index).text()) + '</span></p>';
        },
    },
});